import {useAuth} from '@/middleware/auth'
import {itineraryKey} from '@/utils/helpers'

export default defineNuxtRouteMiddleware(to => {
    const $conf = useNuxtApp().$conf

    if (to.query.key) {
        // TODO [P1] Need to check it
        if (itineraryKey($conf.api.b2cKey, to.params.id) !== to.query.key) {
            return navigateTo({name: 'home'})
        }
    } else {
        return useAuth(to)
    }
})
